var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.3332 8.99982C17.3332 13.6032 13.6023 17.3332 8.99984 17.3332C4.39734 17.3332 0.666504 13.6032 0.666504 8.99982C0.666504 4.39816 4.39734 0.666489 8.99984 0.666489C13.6023 0.666489 17.3332 4.39816 17.3332 8.99982Z",
    fill: "#EB2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99577 11.4404C9.4066 11.4404 9.73327 11.7679 9.73327 12.1696C9.73327 12.5712 9.4066 12.8987 9.0041 12.8987C8.59994 12.8987 8.27077 12.5712 8.27077 12.1696C8.27077 11.7679 8.5966 11.4404 8.99577 11.4404ZM8.99577 5.11307C9.39744 5.11307 9.72494 5.44057 9.72494 5.84223V9.52557C9.72494 9.92723 9.39744 10.2547 8.99577 10.2547C8.5941 10.2547 8.2666 9.92723 8.2666 9.52557V5.84223C8.2666 5.44057 8.5941 5.11307 8.99577 5.11307Z",
    fill: "#EB2D2D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/Info-Circle.801499ceebb9a732c800fcef8c1bb4ca.svg";
export { ForwardRef as ReactComponent };